import React, { Fragment, useContext, useEffect, useState } from "react";
import { Alert, Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BasicContext } from "../App";
import $ from "jquery";
import ContactModal from "./modals/ContactModal";
import { useTranslation } from "react-i18next";

const AlertsContainer = () => {
    const { alerts, setAlerts } = useContext(BasicContext);
    const [showContactModal, setShowContactModal] = useState(false);
    const { t } = useTranslation();

    const closeThisAlert = (i, id) => {
        if (!id) $(".alert-basic").fadeOut(400);
        else $(`#${id}`).fadeOut(400);
        setTimeout(() => {
            let list = [...alerts];
            list.splice(i, 1);
            setAlerts(list);
        }, 400);
    };

    useEffect(() => {
        const alertTimeout = (fading, i) => {
            setTimeout(() => {
                let list = [...alerts];
                list.splice(i, 1);
                setAlerts(list);
            }, fading + 400);
        };

        if (alerts.length > 0) {
            $(".alert-basic").fadeIn(0);
            alerts.forEach((a, i) => {
                if (a.fading) {
                    $(`#${a.id}`).delay(a.fading).fadeOut(400);
                    alertTimeout(a.fading, i);
                }
            });
        } else {
            clearTimeout(alertTimeout(null));
        }
        // eslint-disable-next-line
    }, [alerts]);

    return (
        <Fragment>
            <Container id="alertsContainer">
                <Row>
                    {alerts.map((e, i) => (
                        <Col xs={12} key={i}>
                            <Alert className="alert-basic" style={{ display: "none" }} variant={e.variant} id={e.id}>
                                {e.message}
                                <Button className="btn-close" aria-label="Close alert" variant="btn-link" onClick={() => closeThisAlert(i, e.id)}></Button>
                                {e.link && (
                                    <p className="pt-2">
                                        <Button variant={`outline-${e.variant}`} as={Link} to={e.link.to} onClick={() => closeThisAlert(i, e.id)}>
                                            {e.link.txt}
                                        </Button>
                                    </p>
                                )}
                                {e.contactModal && (
                                    <p className="pt-2">
                                        <Button variant={`outline-${e.variant}`} onClick={() => setShowContactModal(true)}>
                                            {t("menu.contact")}
                                        </Button>
                                    </p>
                                )}
                            </Alert>
                        </Col>
                    ))}
                </Row>
            </Container>
            {showContactModal && <ContactModal onClose={() => setShowContactModal(false)} />}
        </Fragment>
    );
};

export default AlertsContainer;
